import styled from "styled-components";
export const  MainSectionOfPage = styled.div`
  justify-content: space-between;
  padding: 10px;

  .Filter_icon_div {
    width: 50px;
    height: 47px !important;
    border-radius: 30% !important;
    background-color: #f8f9fa !important;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
  .btn_and_icons {
    display: flex;
    justify-content: center;
  }
  .dropdown_list_div {
    background-color: #f8f9fa;
    height: 45px;
    color: #b0b7c3;
    font-size: 14px;
    font-family: "Inter";
    border-radius: 14px;
    border: none;
    background-color: #f8f9fa;
    padding: 6px;
    border: none;
    margin-left: 10px;
  }
  .dropdown_list_div select {
    padding: 4px 14px;
    background-color: transparent;
    border: 0;
    color: #000000;
    font-size: 16px;
    width: auto;
    font-family: "Inter";
    &:focus {
      border: none;
      outline: none;
    }
  }
  option {
    font-size: 16px;
    color: #000000;
    padding: 12px !important;
    font-family: "Inter";
    margin-bottom: 10px !important;
  }

  .sort_by {
    margin-top: 6px;
    margin-right: 10px;
    font-size: 16px;
  }
  .Filter_icon_div img {
    transition: transform 0.3s ease;
  }
`;